// extracted by mini-css-extract-plugin
module.exports = {"user-wrapper":"User_user-wrapper__24zUu"};